import React from 'react';
import { MdMenu, MdLocationOn } from 'react-icons/md';

import useIsMobile from 'hooks/useIsMobile';

import SwitchIcon from './components/SwitchIcon';
import { Container, Title, Subtitle, MapSwitch } from './styles';

interface Props {
  title: string | JSX.Element;
  subtitle?: string | JSX.Element;
  onChange?: (value: number) => void;
  initial?: number;
  hasFilters: boolean;
  hasMap?: boolean;
  isLoading?: boolean;
  isEmpty?: boolean;
}

const HeaderSearchDesktop = ({
  title,
  subtitle,
  onChange,
  initial = 0,
  hasFilters,
  hasMap = true,
  isLoading = false,
  isEmpty,
}: Props) => {
  const isMobile = useIsMobile();

  if (isMobile) return null;

  return (
    <Container className={hasFilters ? 'with-filters' : ''}>
      <Container.Title>
        <Title>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </Container.Title>
      {hasMap && !isEmpty && !isLoading && (
        <MapSwitch>
          <SwitchIcon
            options={[<MdMenu key={0} />, <MdLocationOn key={1} />]}
            initial={initial}
            onChange={(value) => {
              if (onChange) onChange(value);
            }}
          />
        </MapSwitch>
      )}
    </Container>
  );
};

export default HeaderSearchDesktop;
